<template>
  <div class="card">
    <div class="card-header"><h2 style="font-size: 22px;">Amendment Documentation</h2></div>
    <div class="card-body">
      <b-row>
        <b-col>
          <b-alert variant="danger" dismissible :show="!printCheck && isSubmitted">
            You must print the coversheet to enclose with your amendment documents.
          </b-alert>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col class="justify-content-center d-flex" cols="12">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-sign-stop-fill text-danger" viewBox="0 0 16 16" style="font-size: 12rem">
            <path d="M10.371 8.277v-.553c0-.827-.422-1.234-.987-1.234-.572 0-.99.407-.99 1.234v.553c0 .83.418 1.237.99 1.237.565 0 .987-.408.987-1.237m2.586-.24c.463 0 .735-.272.735-.744s-.272-.741-.735-.741h-.774v1.485z"/>
            <path d="M4.893 0a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146A.5.5 0 0 0 11.107 0zM3.16 10.08c-.931 0-1.447-.493-1.494-1.132h.653c.065.346.396.583.891.583.524 0 .83-.246.83-.62 0-.303-.203-.467-.637-.572l-.656-.164c-.61-.147-.978-.51-.978-1.078 0-.706.597-1.184 1.444-1.184.853 0 1.386.475 1.436 1.087h-.645c-.064-.32-.352-.542-.797-.542-.472 0-.77.246-.77.6 0 .261.196.437.553.522l.654.161c.673.164 1.06.487 1.06 1.11 0 .736-.574 1.228-1.544 1.228Zm3.427-3.51V10h-.665V6.57H4.753V6h3.006v.568H6.587Zm4.458 1.16v.544c0 1.131-.636 1.805-1.661 1.805-1.026 0-1.664-.674-1.664-1.805V7.73c0-1.136.638-1.807 1.664-1.807s1.66.674 1.66 1.807ZM11.52 6h1.535c.82 0 1.316.55 1.316 1.292 0 .747-.501 1.289-1.321 1.289h-.865V10h-.665V6.001Z"/>
          </svg>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="justify-content-center d-flex font-weight-bold">
          Action required to complete your amendment request!
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="justify-content-center d-flex font-weight-bold">
          You must send us documents to finish your order.
        </b-col>
      </b-row>
      <b-row class="mt-3">
          <b-col>
            Documents are required for amendments. You must send us documents to support the changes you want to make to a birth or death record. Depending on the
            record you want to amend, and the changes you want to make, the type of documents that we can accept differ. All documentation must be original, certified
            or authenticated, legible, unmodified, and written in English.
          </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="font-weight-bold">
          To help you identify and determine what documents are acceptable, read the information in
          <a href="https://www.health.state.mn.us/people/vitalrecords/reqdocs.html" target="_blank">
            Supporting Documents for Amendments - opens in new tab</a>
          published by the MN Dept. of Health.
          We cannot amend a record without your documents.
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          Use the button below to print your coversheet and enclose the coversheet with your amendment documents.
          The cover sheet helps us find and process your online order.
          Sending us documents without a cover sheet may delay the amendment.
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <router-link :to="{name: 'coversheet'}" target="_blank">
            <b-button variant="success" class="mt-2" @click="coversheet()">Print Cover Sheet</b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="6">
          <p class="font-weight-bold">Send your documents and cover sheet by mail to:</p>
          <div>Minnesota Department of Health</div>
          <div>Office of Vital Records</div>
          <div>PO Box 64499</div>
          <div>St. Paul, MN 55164-0499</div>
        </b-col>
        <b-col md="6">
          <p class="font-weight-bold">Send your documents and cover sheet by courier/express delivery:</p>
          <div>Minnesota Department of Health</div>
          <div>Office of Vital Records</div>
          <div>625 Robert St. N</div>
          <div>St. Paul, MN 55155</div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          After we amend the record, we will return the documents to you.
        </b-col>
      </b-row>
    </div>
  </div>

</template>
<script>
import axios from "axios"
import axiosRetry from 'axios-retry'
import LocalStorageService from "@/common/LocalStorageService";

axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  })

const localStorageService = LocalStorageService.getService();

export default {
  data: () => {
    return {
      printCheck: false,
      isSubmitted: false,
    }
  },
  props: {
    orderNumber: [String],
  },
  validations() {
    return {
      printed: {
        check(){
          return this.printCheck === true;
        }
      }
    }
  },
  methods: {
    coversheet() {
      this.printCheck = true
    },
    validate() {
      this.isSubmitted = true;
      this.$v.printed.$touch();
      let isValid = !this.$v.printed.$invalid;
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    },
  }
}
</script>
